'use client'

import { useMemo } from 'react'
import useSWR from 'swr'
import { formatUnits } from 'viem'

import { TokenType } from '../types'

interface TokenSupplyResponse {
  supply: string
  timestamp: string
}

type UseTokenSupply = {
  isLoading: boolean
  tokenSupply: number | undefined
  lastUpdated: string | undefined
}

export const useTokenSupply = (token: TokenType): UseTokenSupply => {
  const { data, isLoading } = useSWR<TokenSupplyResponse>(`/api/solvency/token-supply?symbol=${token}`)

  const tokenSupply = useMemo(() => {
    const supply = data?.supply ? BigInt(data?.supply) : undefined

    return supply ? Number(formatUnits(supply, 18)) : undefined
  }, [data])

  return { isLoading, lastUpdated: data?.timestamp, tokenSupply }
}
